import React from 'react';
import FieldObject from './field_object';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import TextOption from './text_option';
import NumberOption from './number_option';
import DateOption from './date_option';
import CurrencyOption from './currency_option';
import YesNoOption from './yes_no_option';
import SelectOption from './select_option';

type Props = {
  fetchOptions: (id: string, term: string) => Promise<{ items: Item[] }>;
  currencies: Item[];
  index: number;
  isApplication?: boolean;
};

const CustomFieldOptions = ({
  fetchOptions,
  currencies,
  index,
  isApplication,
}: Props) => {
  const { watch, setValue } = useFormContext();
  const customFields: FieldObject[] = isApplication
    ? watch('application_fields')
    : watch('custom_fields');

  const fieldObject = customFields[index];
  const valueType = fieldObject.valueType();

  const handleUpdate = (updatedFieldObject: FieldObject) => {
    customFields[index] = updatedFieldObject;
    setValue(
      isApplication ? 'application_fields' : 'custom_fields',
      customFields
    );
  };

  if (fieldObject.isTextOption()) {
    return <TextOption fieldObject={fieldObject} onUpdate={handleUpdate} />;
  } else if (fieldObject.isNumberOption()) {
    return <NumberOption fieldObject={fieldObject} onUpdate={handleUpdate} />;
  } else if (fieldObject.isDateOption()) {
    return <DateOption fieldObject={fieldObject} onUpdate={handleUpdate} />;
  } else if (fieldObject.isYesNoOption()) {
    return <YesNoOption fieldObject={fieldObject} onUpdate={handleUpdate} />;
  } else if (fieldObject.isCurrencyOption()) {
    return (
      <CurrencyOption
        fieldObject={fieldObject}
        currencies={currencies}
        onUpdate={handleUpdate}
      />
    );
  } else if (fieldObject.isSelectOption()) {
    return (
      <SelectOption
        fieldObject={fieldObject}
        fetchOptions={fetchOptions}
        onUpdate={handleUpdate}
      />
    );
  }

  throw 'Unsupported custom field type: ' + valueType;
};

export default CustomFieldOptions;
